import { z } from 'zod';

const emailSchema = z.string().email();

export function isEmail (value: string) {
  try {
    emailSchema.parse(value);
    return true;
  } catch (_) {
    return false;
  }
}

